import { useEffect, useState } from "react";
import {
  Autocomplete,
  FormControl,
  Grid,
  TextField,
} from "../../../components";
import { filtrosUrl, value } from "../../../helpers";
import { GrupoPessoasService } from "../../../services";
import { cacheApi, responseErros } from "../../../utils";

export default function TabTransportadora({
  transportadoraSelecionada,
  linhaSelecionada,
  cacheDto,
  setCacheDto,
  inputErros,
}) {
  const [listaGrupoPessoa, setListaGrupoPessoa] = useState([]);
  const [transportadora, setTransportadora] = useState(transportadoraSelecionada);

  const grupoPessoasService = new GrupoPessoasService();

  useEffect(() => {
    buscaGruposPessoas();
  }, []);

  const buscaGruposPessoas = async () => {
    const filtros = {
      ativado: true,
      tipoPessoa: 3,
      restritiva: true,
    };
    const label = filtrosUrl.getUrl(filtros, grupoPessoasService.urlBase);
    const cacheBody = {
      apiFunction: grupoPessoasService.getAllFiltroAvancado(filtros),
      dto: { cacheDto, setCacheDto },
    };
    const res = await cacheApi(label, cacheBody);
    if (!res.isAxiosError) {
      setListaGrupoPessoa(res.data.rows);
    } else {
      responseErros(res);
    }
  };

  const handleChangeAutocomplete = (name, value) => {
    transportadoraSelecionada.setAtributo(name, value?.id);
    setTransportadora({ ...transportadoraSelecionada });
  };

  const handleChangeInput = (event) => {
    const { name, value } = event.target;
    transportadoraSelecionada.setAtributo(name, value);
    setTransportadora({ ...transportadoraSelecionada });
  };

  return (
    <Grid container spacing={2} className="mt-1">
      <Grid item xs={4}>
        <FormControl variant="outlined" margin="normal" fullWidth>
          <Autocomplete
            id="grupoPessoaId"
            name="grupoPessoaId"
            options={listaGrupoPessoa}
            noOptionsText="Sem opções"
            autoHighlight
            getOptionLabel={(option) => (option.nome ? option.nome : "")}
            filterSelectedOptions
            onChange={(_, value) =>
              handleChangeAutocomplete("grupoPessoaId", value)
            }
            renderInput={(params) => (
              <TextField {...params} label="Grupos de Pessoas" />
            )}
            value={value.autoComplete(
              listaGrupoPessoa,
              transportadora?.grupoPessoaId,
            )}
          />
        </FormControl>
      </Grid>
      <Grid item xs={4}>
        <TextField
          label="Local Embarque (Exportação)"
          name="localEmbarque"
          margin="normal"
          fullWidth
          required
          value={transportadora?.localEmbarque ?? ""}
          onChange={handleChangeInput}
          error={inputErros?.get(`[${linhaSelecionada}].transportadora.localEmbarque`)}
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          label="Local Desembarque (Exportação)"
          name="localDesembarque"
          margin="normal"
          fullWidth
          value={transportadora?.localDesembarque ?? ""}
          onChange={handleChangeInput}
          error={inputErros.get("localDesembarque")}
        />
      </Grid>
      <Grid item xs={2}>
        <TextField
          label="RNTC"
          name="rntc"
          type="number"
          fullWidth
          value={transportadora?.rntc ?? ""}
          onChange={handleChangeInput}
        />
      </Grid>
    </Grid>
  );
}
